import { PortalTypeEnum } from '../login/login.model';
import { retry } from 'rxjs/operator/retry';

export class ProductModel {
    recUID: string;
    recID: number;
    vart: number;
    groupID: string;
    groupName: string;
    quantityUnit: string;
    hasImage: boolean;
    imagePath: string;
    productDescriptions: any[];
    productAttributes: any[];
    productRetailPrices: any[];
    localizedAttributes: { string: { string: TnProductAttribute } };
    productLimitedSlots: ProductLimitedSlot[];
    productTaxes: any[];
    trainClasses: number[];
    businessType: PortalTypeEnum;
    unitsInPackage: number;

    // selectedCustomerClasses: boolean[] = [false, false, false, false, false, false];
}

export class ProductLimitedSlot {
    slotID: string;
    selected: boolean
    name: string;
}

export class TnProductAttribute {
    ProductRecID: number;
    Name: string;
    Value: string;
    Product: ProductModel;
    constructor(ProductRecID?: number, Name?: string, Value?: string, Product?: ProductModel) {
        this.Name = Name;
        this.ProductRecID = ProductRecID;
        this.Value = Value;
        this.Product = Product;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/product-dialog/product.model.ts